import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import OurStoryPage from '@/pages/our-story/page';
import TheEstatePage from '@/pages/the-estate/page';
import SpeysidePage from '@/pages/speyside/page';
import HighlandsPage from '@/pages/highlands/page';
import ProductPage from '@/pages/product/page';
import ShopPage from '@/pages/shop/page';
import WhiskiesPage from '@/pages/whiskies/page';
import GinsPage from '@/pages/gins/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';
import AdminLoginPage from '@/pages/admin/login/page';
import AdminLayout from '@/pages/admin/components/AdminLayout';
import AdminDashboard from '@/pages/admin/dashboard/page';
import AdminHeroPage from '@/pages/admin/hero/page';
import AdminColorsPage from '@/pages/admin/colors/page';
import AdminFooterPage from '@/pages/admin/footer/page';
import AdminLogoPage from '@/pages/admin/logo/page';
import AdminSectionsPage from '@/pages/admin/sections/page';
import AdminMediaPage from '@/pages/admin/media/page';
import AdminSettingsPage from '@/pages/admin/settings/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/loja', element: <ShopPage /> },
  { path: '/whiskies', element: <WhiskiesPage /> },
  { path: '/gins', element: <GinsPage /> },
  { path: '/our-story', element: <OurStoryPage /> },
  { path: '/the-estate', element: <TheEstatePage /> },
  { path: '/speyside', element: <SpeysidePage /> },
  { path: '/descubra-as-highlands', element: <HighlandsPage /> },
  { path: '/produto/:slug', element: <ProductPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/admin/login', element: <AdminLoginPage /> },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: 'hero', element: <AdminHeroPage /> },
      { path: 'colors', element: <AdminColorsPage /> },
      { path: 'footer', element: <AdminFooterPage /> },
      { path: 'logo', element: <AdminLogoPage /> },
      { path: 'sections/:type', element: <AdminSectionsPage /> },
      { path: 'media', element: <AdminMediaPage /> },
      { path: 'settings', element: <AdminSettingsPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;
